import styled from '@emotion/styled'

import { fadeIn } from '../../SearchNearParking.styled'

export const MobileFiltersButtonWrapper = styled.div<{
  isFixed: boolean
  isVisible: boolean
}>`
  background: ${({ isFixed }) => (isFixed ? '#f2f6fd' : 'transparent')};
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  margin-bottom: ${({ isFixed }) => (isFixed ? '0' : '4px')};
  position: ${({ isFixed }) => (isFixed ? 'fixed' : 'relative')};
  bottom: ${({ isFixed }) => (isFixed ? '0' : 'unset')};
  left: ${({ isFixed }) => (isFixed ? '0' : 'unset')};
  padding: ${({ isFixed }) => (isFixed ? '16px 24px 28px 16px' : 'unset')};
  width: ${({ isFixed }) => (isFixed ? '100vw' : 'unset')};
  animation: ${({ isVisible }) => (isVisible ? fadeIn : 'none')} 0.3s linear;
  z-index: ${({ isFixed }) => (isFixed ? '20' : '0')};
  box-shadow: ${({ isFixed }) =>
    isFixed ? '0px -4px 24px 0px rgba(9, 55, 105, 0.08)' : 'unset'};
  gap: 16px;
`

export const ContentWrapper = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
`
